import {
	ValidationEbook
} from './ValidationEbook';
export class EbookForm {
	constructor () {
		this.$container = document.querySelector('[data-js-ebook]');
		if (this.$container) {
			this.CONTAINER_CLASS = 'm-EbookForm';
			this.valiadation = new ValidationEbook();
			this.$formGroup = [...this.$container.querySelectorAll('.form-group')];
			this.tags = {
				input: 'input',
				textarea: 'textarea',
				select: 'select',
				label: 'label'
			};
			this.types = {
				text: 'text'
			};
			this.activeClasses = {
				textUp: `${this.CONTAINER_CLASS}--textup`,
				textFilled: `${this.CONTAINER_CLASS}--textfilled`
			};
			this.init();
		}
	}

	init () {
		this.$formGroup.forEach($el => {
			const $element = $el.querySelector(
				`${this.tags.input}, ${this.tags.textarea}, ${this.tags.select}`
			);
			const $label = $el.querySelector(`${this.tags.label}`);
			let tagname = $element.tagName.toLowerCase();
			let type = $element.getAttribute('type');
			if ((tagname === this.tags.input && type === this.types.text) || tagname === this.tags.textarea) {
				this.focusText($element, $label);
				this.filledText($element, $label);
			}
		});
	}

	focusText ($element, $label) {
		let $parent = $label.parentElement;
		$element.onfocus = () => {
			$parent.classList.add(this.activeClasses.textUp);
		};
		$element.onfocusout = () => {
			$parent.classList.remove(this.activeClasses.textUp);
		};
	}
	filledText ($element, $label) {
		let $parent = $label.parentElement;

		if ($element.value.length > 0){
			$parent.classList.add(this.activeClasses.textFilled);
		}else{
			$parent.classList.remove(this.activeClasses.textFilled);
		}

		$element.oninput = () => {
			if ($element.value.length > 0){
				$parent.classList.add(this.activeClasses.textFilled);
			}else{
				$parent.classList.remove(this.activeClasses.textFilled);
			}
		};
	}
}
